// extracted by mini-css-extract-plugin
export var grayCircle = "_dw-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_dw-1";
export var selectedCircle = "_dw-2";
export var shippingOptionImage = "_dw-3";
export var shippingOptionWidgetPreview = "_dw-4";